var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginOption5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7602_61457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1085 16.2261L0.645996 25.0834L6.98566 23.4991L9.8335 28.0001L13.2635 20.9324C9.91983 20.5789 7.00433 18.8009 5.1085 16.2261Z",
    fill: "#49494A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8918 16.2261L28.3543 25.0834L22.0146 23.4991L19.1668 28.0001L15.7368 20.9324C19.0805 20.5789 21.996 18.8009 23.8918 16.2261Z",
    fill: "#49494A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5003 0C9.35416 0 5.16699 4.18717 5.16699 9.33333C5.16699 14.4795 9.35416 18.6667 14.5003 18.6667C19.6465 18.6667 23.8337 14.4795 23.8337 9.33333C23.8337 4.18717 19.6465 0 14.5003 0ZM14.5003 11.6667C13.2112 11.6667 12.167 10.6225 12.167 9.33333C12.167 8.04417 13.2112 7 14.5003 7C15.7895 7 16.8337 8.04417 16.8337 9.33333C16.8337 10.6225 15.7895 11.6667 14.5003 11.6667Z",
    fill: "#49494A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7602_61457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginOption5);
export default __webpack_public_path__ + "static/media/login-option-5.05e72211fb9c402e83efd3d9f704691c.svg";
export { ForwardRef as ReactComponent };